import React from 'react';
import { BrandLink } from './BrandLink';

export default function Footer() {
  return (
    <footer className="mt-8 mb-4 text-center select-none">
      <p className="text-xs font-medium tracking-wide text-slate-600 dark:text-slate-400">
        <BrandLink />
      </p>
    </footer>
  );
}
